import { Alert, Slide, Snackbar } from '@mui/material';
import React, { useState, createContext } from 'react';
import { Outlet } from 'react-router-dom';

export type Notification_Prompt_Type = 'success' | 'error' | 'info' | 'warning';

interface Context_Type {
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  setSeverity: React.Dispatch<React.SetStateAction<Notification_Prompt_Type>>;
  handleSnackbarOpen: (forceCenter?: boolean) => void;
  handleSnackbarClose: () => void;
}

export const SnackbarContext = createContext<Context_Type>({
  setMessage: () => {},
  setSeverity: () => {},
  handleSnackbarOpen: () => {},
  handleSnackbarClose: () => {},
});

function AppLayout() {
  const [open,     setOpen]     = useState<boolean>(false);
  const [message,  setMessage]  = useState<string>('A dummy message!');
  const [severity, setSeverity] = useState<Notification_Prompt_Type>('success');

  const handleClose: Context_Type['handleSnackbarClose'] = () => setOpen(false);
  const handleOpen:  Context_Type['handleSnackbarOpen']  = () => setOpen(true);

  return (
    <>
      <SnackbarContext.Provider
        value={{
          setMessage,
          setSeverity,
          handleSnackbarOpen: handleOpen,
          handleSnackbarClose: handleClose,
        }}
      >
        <Outlet />
      </SnackbarContext.Provider>

      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        TransitionComponent={Slide}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          icon={false}
          severity={severity}
          variant="standard"
          onClose={handleClose}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default AppLayout;
